import type { ErrorInfo, ReactNode } from "react";
import {
  type FallbackProps,
  ErrorBoundary as ReactErrorBoundary,
} from "react-error-boundary";
import { ErrorPage } from "../ErrorPage/ErrorPage";

interface Props {
  children: ReactNode;
  onError: (error: unknown, info?: ErrorInfo) => void;
}

// Define the FallbackComponent - Use FallbackProps and assert error type
function FallbackComponent({ error }: FallbackProps) {
  // Assert error as Error type for safe access
  const typedError = error as unknown as Error;
  return (
    <ErrorPage
      message={typedError?.message ?? "An unexpected error occurred."}
    />
  );
}

// Define the new ErrorBoundary component using the imported one
export function ErrorBoundary({ children, onError }: Props) {
  return (
    <ReactErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
      {children}
    </ReactErrorBoundary>
  );
}
